<template>
    <div>
        <my-header :breadcrumb="breadcrumb"></my-header>
        <el-card class="box-card">
            <!--搜索-->
            <el-button type="primary" @click="showDialog">添加</el-button>
            <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="60%">
                <el-form :model="form" :rules="rules" ref="ruleForm">
                    <el-form-item label="角色名称" :label-width="formLabelWidth" prop="role_name">
                        <el-input v-model="form.role_name"></el-input>
                    </el-form-item>
                    <el-form-item label="管理权限" :label-width="formLabelWidth">
                        <el-table
                                :data="menuList"
                                border
                                style="width: 100%;margin:20px 0 0 0;"
                                row-key="id"
                                :default-sort="{prop: 'order_sort', order: 'ascending'}"
                                default-expand-all
                                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                        >

                            <el-table-column
                                    prop="menu_name"
                                    label="菜单名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    label="权限分配"
                            >
                                <template slot-scope="scope">
                                    <div style="display: none;" v-model="form.arrId[scope.$index]=scope.row.id"></div>
                                    <el-checkbox-group v-model="form.checkList[scope.$index]">
                                        <el-checkbox :label="item.permission_code"
                                                     v-for="(item,index) in scope.row.menuPermissions" :key="index">
                                            {{item.permission_name}}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </template>
                            </el-table-column>


                        </el-table>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="clickAdd('ruleForm')">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 工具栏（列表名称、列表显示项设置） -->
            <!--列表内容-->
            <el-table
                    :data="tableData"
                    style="width: 100%;margin:20px 0 0 0;"
                    row-key="id"
                    :default-sort="{prop: 'order_sort', order: 'ascending'}"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            >

                <el-table-column
                        prop="name"
                        label="角色名称"
                        sortable
                >
                </el-table-column>


                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-card>
    </div>
</template>

<script>
    import MyHeader from "../header";

    export default {
        name: "role-list",
        components: {MyHeader},
        data() {
            return {
                breadcrumb: [
                    {name: '权限管理'},
                    {name: '角色列表'}
                ],
                dialogFormVisible: false,
                form: {
                    checkList: [],
                    arrId: [],
                    role_name: ''
                },
                formLabelWidth: '120px',
                dialogTitle: '添加菜单',
                menuList: [],
                tableData: [],
                actionTypeList: {
                    show: '显示',
                    add: '添加',
                    edit: '修改',
                    delete: '删除'
                },
                rules: {
                    role_name: [
                        {required: true, message: '请输入角色名称', trigger: 'blur'},
                    ]
                },
              parentId:0
            }
        },
        created() {
            this.getRoleList();
        },
        methods: {
            getRoleList() {
                this.$http.get('/v1/auth-item/role-list').then(({data}) => {
                    this.tableData = data;
                })
            },
            showDialog() {
              this.form = {
                checkList: [],
                    arrId: [],
                    role_name: ''
              }
                this.$http.get('/v1/menu/all-list', {params: {parentId: this.parentId}}).then(({data}) => {
                    //console.log(data)
                    var a = 0;
                    var b = 0;
                    for (let i in data) {
                        a++;
                        data[i].order_sort = parseInt(data[i].order_sort)
                        if (!data[i].children) {
                        } else {
                            var child = data[i].children;
                            for (let m in data[i].children) {
                                b++;
                                child[m].order_sort = parseInt(child[m].order_sort)
                            }
                        }

                    }
                    this.menuList = data;
                    //this.totalCount = parseInt(data.result.totalCount);
                    var menuCount = a + b;
                    //console.log(menuCount)
                    for (let c = 0; c < menuCount; c++) {
                        this.$set(this.form.checkList, c, [])
                    }
                    //console.log(this.form.checkList)

                })
                this.dialogFormVisible = true;
            },
            handleEdit(index, row) {
                this.dialogTitle = '修改角色';
                this.$http.get('/v1/auth-item/view', {params: {name: row.name}}).then(({data}) => {
                    this.form.role_name = data.result.role.name;
                    this.form.type = data.result.role.type;
                    this.form.permissions = data.result.permissions;
                    this.$http.get('/v1/menu/all-list', {params: {parentId: this.parentId}}).then(({data}) => {
                        var a = 0;
                        var b = 0;
                        this.form.arrId = [];
                        for (let i in data) {
                            a++;
                            this.form.arrId.push(data[i].id)
                            data[i].order_sort = parseInt(data[i].order_sort)
                            if (!data[i].children) {
                            } else {
                                var child = data[i].children;
                                for (let m in data[i].children) {
                                    b++;
                                    this.form.arrId.push(child[m].id)
                                    child[m].order_sort = parseInt(child[m].order_sort)
                                }
                            }
                        }
                        this.menuList = data;
                        //this.totalCount = parseInt(data.result.totalCount);
                        var menuCount = a + b;
                        //console.log(menuCount)
                        //初始化checkList
                        for (let c = 0; c < menuCount; c++) {
                            this.$set(this.form.checkList, c, [])
                        }
                        //console.log(this.form.permissions)
                        //console.log(this.form.arrId)
                        for (let e = 0; e < this.form.arrId.length; e++) {
                            for (let d in this.form.permissions) {
                                if (this.form.arrId[e] == this.form.permissions[d].menu_id) {
                                    this.form.checkList[e].push(this.form.permissions[d].permission_code)
                                }
                            }
                        }
                    })

                })
                this.dialogFormVisible = true;
            },
            handleDelete(index, row) {
                this.$http.delete('/v1/auth-item/delete',{params:{role_name:row.name}}).then(({data})=>{
                    if (data.errcode == 0){
                        this.$message.success(data.msg);
                    }else{
                        this.$message.error(data.msg);
                    }
                })
            },
            clickAdd(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        //console.log(this.form.type)
                        if (typeof this.form.type == 'undefined') {

                            this.$http.post('/v1/auth-item/create', this.form).then(({data}) => {
                                if (data.errcode == 0) {
                                    this.$message.success(data.msg)
                                    this.dialogFormVisible = false;
                                    this.getRoleList();
                                }
                            })
                        } else {
                            this.$http.patch('/v1/auth-item/update', this.form).then(({data}) => {
                                if (data.errcode == 0) {
                                    this.$message.success(data.msg)
                                    this.dialogFormVisible = false;
                                    this.getRoleList();
                                }
                            })
                        }

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            }
        }
    }
</script>

<style scoped>
    .box-card {
        margin: 20px;
    }

    .pages {
        text-align: right;
        margin: 20px 0 0 0;
    }

    .goods-image, .goods-image img {
        float: left;
    }

    .goods-name {
        display: inline-block;
        margin: 0 0 0 10px;
        width: 290px;
    }

    .form-dialog {
        width: 60%;
    }
</style>
